// import React, { useEffect, useState, useContext, useMemo } from "react";
// import { toast } from "react-toastify";
// import { getSharePayment } from "../../../Utility/Api";
// import { WarehouseContext } from "../../../Utility/UserContext";

// const SharePaymentReport = () => {
//     const { showLoader, hideLoader, shopItem } = useContext(WarehouseContext);

//     const [rows, setRows] = useState([]);
//     const [loading, setLoading] = useState(true);

//     const [parentFilter, setParentFilter] = useState("all");
//     const [shareholderFilter, setShareholderFilter] = useState("all");
//     const [amountFrom, setAmountFrom] = useState("");
//     const [amountTo, setAmountTo] = useState("");

//     useEffect(() => {
//         fetchPaymentData();
//         // eslint-disable-next-line
//     }, []);

//     // 🔥 FETCH + FLATTEN
//     const fetchPaymentData = async () => {
//         try {
//             showLoader();

//             const res = await getSharePayment({
//                 shop_id: shopItem?.shop_id,
//             });

//             if (res?.data?.status === "success") {
//                 const flat = res.data.data.flatMap(tx =>
//                     (tx.distribution_breakup || []).map(item => ({
//                         transaction_id: tx.transaction_id,
//                         date: tx.date,
//                         parent_id: tx.parent_id,
//                         parent_name: item.parent_name,
//                         shareholder_id: item.shareholder_id,
//                         shareholder_name: item.name,
//                         equity: item.equity || item.equity_percent,
//                         amount: Number(item.amount) || 0,
//                         is_parent: String(item.shareholder_id) === String(tx.parent_id),
//                         equity_percent: tx.equity_percent
//                     }))
//                 );

//                 setRows(flat);
//             } else {
//                 setRows([]);
//             }
//         } catch (error) {
//             console.log(error.response?.data);
//             // toast.error(error?.data?.message ||"Failed to load report");
//             toast.error(
//                 error?.response?.data?.message || "Failed to load report"
//             );

//             setRows([]);
//         } finally {
//             hideLoader();
//             setLoading(false);
//         }
//     };

//     const filteredRows = useMemo(() => {
//         return rows.filter(r => {
//             if (parentFilter !== "all" && r.parent_id !== parentFilter) return false;
//             if (shareholderFilter !== "all" && String(r.shareholder_id) !== shareholderFilter) return false;
//             if (amountFrom && r.amount < Number(amountFrom)) return false;
//             if (amountTo && r.amount > Number(amountTo)) return false;
//             return true;
//         });
//     }, [rows, parentFilter, shareholderFilter, amountFrom, amountTo]);

//     const overallTotal = useMemo(
//         () => rows.reduce((s, r) => s + r.amount, 0),
//         [rows]
//     );

//     const filteredTotal = useMemo(
//         () => filteredRows.reduce((s, r) => s + r.amount, 0),
//         [filteredRows]
//     );

//     const parents = [...new Map(rows.map(r => [r.parent_id, r])).values()];
//     const shareholders = [...new Map(rows.map(r => [r.shareholder_id, r])).values()];

//     return (
//         <div className="p-4 bg-white">

//             <h5 className="fw-bold mb-1">Shareholder Profit Report</h5>
//             <div className="d-flex align-items-end  justify-content-end  gap-3 mb-1">

//                 {/* <div style={{ minWidth: "150px" }}>
//                     <label className="form-label mb-1 fw-semibold">Parent</label>
//                     <select
//                         className="form-select"
//                         value={parentFilter}
//                         onChange={(e) => setParentFilter(e.target.value)}
//                     >
//                         <option value="all">All Parents</option>
//                         {parents.map(p => (
//                             <option key={p.parent_id} value={p.parent_id}>
//                                 {p.parent_name}
//                             </option>
//                         ))}
//                     </select>
//                 </div> */}

//                 <div style={{ minWidth: "150px" }}>
//                     <label className="form-label mb-1 fw-semibold ">Shareholder</label>
//                     <select
//                         className="form-select"
//                         value={shareholderFilter}
//                         onChange={(e) => setShareholderFilter(e.target.value)}
//                     >
//                         <option value="all">All Shareholders</option>
//                         {shareholders.map(s => (
//                             <option key={s.shareholder_id} value={s.shareholder_id}>
//                                 {s.shareholder_name}
//                             </option>
//                         ))}
//                     </select>
//                 </div>

//             </div>


//             {/* SUMMARY */}
//             <div className="alert alert-light border d-flex justify-content-between mb-2">
//                 <strong>Total Profit (All): ₹{overallTotal.toLocaleString("en-IN")}</strong>
//                 <strong>Filtered Total: ₹{filteredTotal.toLocaleString("en-IN")}</strong>
//             </div>

//             {/* TABLE */}
//             <div className="table-responsive">
//                 <table className="table table-bordered table-hover">
//                     <thead className="table-light">
//                         <tr>
//                             <th>#</th>
//                             <th>Date</th>
//                             <th>Parent</th>
//                             <th>Shareholder</th>
//                             <th className="text-center">Equity</th>
//                             <th className="text-center">Amount</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {loading ? (
//                             <tr><td colSpan="6" className="text-center">Loading...</td></tr>
//                         ) : filteredRows.length === 0 ? (
//                             <tr><td colSpan="6" className="text-center text-muted">No records</td></tr>
//                         ) : (
//                             filteredRows.map((r, i) => (
//                                 <tr key={i} className={r.is_parent ? "table-primary" : ""}>
//                                     <td>{i + 1}</td>
//                                     <td>{r.date}</td>
//                                     <td>
//                                         {r.parent_name}
//                                         {r.is_parent && (
//                                             <span className="badge bg-primary ms-2">PARENT ({r.equity_percent}%)</span>
//                                         )}
//                                     </td>
//                                     <td>{r.shareholder_name}</td>
//                                     <td className="text-center">
//                                         {r.equity === "Remaining" ? "Remaining" : `${r.equity}%`}
//                                     </td>
//                                     <td className="text-center fw-bold text-success">
//                                         ₹{r.amount.toLocaleString("en-IN")}
//                                     </td>
//                                 </tr>
//                             ))
//                         )}
//                     </tbody>
//                 </table>
//             </div>
//         </div>
//     );
// };

// export default SharePaymentReport;


// now use 

import React, { useEffect, useState, useContext, useMemo } from "react";
import { toast } from "react-toastify";
import { getSharePayment, getShareHolders, createEquityEntry, getBankBalance } from "../../../Utility/Api";
import { WarehouseContext } from "../../../Utility/UserContext";

const SharePaymentReport = () => {
    const { showLoader, hideLoader, shopItem } = useContext(WarehouseContext);

    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);

    const [shareholderFilter, setShareholderFilter] = useState("all");
    const [amountFrom, setAmountFrom] = useState("");
    const [amountTo, setAmountTo] = useState("");

    // Pay Modal State
    const [showPayModal, setShowPayModal] = useState(false);
    const [payData, setPayData] = useState({
        shareholder_id: "",
        amount: "",
        date: new Date().toISOString().split("T")[0],
        remarks: ""
    });
    const [allShareholders, setAllShareholders] = useState([]);
    const [bankBalance, setBankBalance] = useState(0);

    const UserItem = JSON.parse(localStorage.getItem('UserItem') || "{}");

    useEffect(() => {
        fetchPaymentData();
        fetchPayData();
        // eslint-disable-next-line
    }, []);

    const fetchPayData = async () => {
        try {
            const [shRes, bankRes] = await Promise.all([
                getShareHolders({ shop_id: shopItem?.shop_id || shopItem?.id }),
                getBankBalance(shopItem?.shop_id || shopItem?.id)
            ]);
            if (shRes?.data?.status === "success") {
                setAllShareholders(shRes.data.data || []);
            }
            if (bankRes?.data?.status === "success") {
                setBankBalance(bankRes.data.bank_balance || 0);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handlePaySubmit = async (e) => {
        e.preventDefault();
        
        if (!payData.shareholder_id) {
            toast.error("Please select a shareholder");
            return;
        }

        if (Number(payData.amount) <= 0) {
            toast.error("Amount must be greater than 0");
            return;
        }

        if (Number(payData.amount) > Number(bankBalance)) {
            toast.error("Amount cannot be greater than bank balance");
            return;
        }

        try {
            showLoader();
            const res = await createEquityEntry({
                shop_id: shopItem?.shop_id || shopItem?.id,
                shareholder_id: payData.shareholder_id,
                amount: payData.amount,
                date: payData.date,
                remarks: payData.remarks,
                created_by: UserItem?.user_id
            });

            if (res?.data?.status === "success") {
                toast.success("Payment recorded successfully");
                setShowPayModal(false);
                setPayData({
                    ...payData,
                    amount: "",
                    remarks: ""
                });
                fetchPaymentData();
                fetchPayData(); // refresh bank balance
            } else {
                toast.error(res?.data?.message || "Failed to process payment");
            }
        } catch (error) {
            console.error(error);
            toast.error(error?.response?.data?.message || "Failed to process payment");
        } finally {
            hideLoader();
        }
    };

    // 🔥 FETCH + FLATTEN (CORRECT PARENT LOGIC)
    const fetchPaymentData = async () => {
        try {
            showLoader();

            const res = await getSharePayment({
                shop_id: shopItem?.shop_id,
            });

            if (res?.data?.status === "success") {
                const flat = res.data.data.flatMap(tx =>
                    (tx.distribution_breakup || []).map(item => ({
                        transaction_id: tx.transaction_id,
                        date: tx.date,

                        parent_id: item.parent_id,
                        parent_name: item.parent_name,

                        shareholder_id: item.shareholder_id,
                        shareholder_name: item.name,

                        equity: item.equity,
                        amount: Number(item.amount) || 0,

                        // ✅ Correct parent detection
                        is_parent:
                            String(item.shareholder_id) ===
                            String(item.parent_id),
                    }))
                );

                setRows(flat);
            } else {
                setRows([]);
            }
        } catch (error) {
            console.error(error);
            toast.warning(
                error?.response?.data?.message || "Failed to load report"
            );
            setRows([]);
        } finally {
            hideLoader();
            setLoading(false);
        }
    };

    // 🔍 FILTERED ROWS
    const filteredRows = useMemo(() => {
        return rows.filter(r => {
            if (
                shareholderFilter !== "all" &&
                String(r.shareholder_id) !== shareholderFilter
            )
                return false;

            if (amountFrom && r.amount < Number(amountFrom)) return false;
            if (amountTo && r.amount > Number(amountTo)) return false;

            return true;
        });
    }, [rows, shareholderFilter, amountFrom, amountTo]);

    // 💰 TOTALS
    const overallTotal = useMemo(
        () => rows.reduce((sum, r) => sum + r.amount, 0),
        [rows]
    );

    const filteredTotal = useMemo(
        () => filteredRows.reduce((sum, r) => sum + r.amount, 0),
        [filteredRows]
    );

    // 🎯 UNIQUE SHAREHOLDERS FOR FILTER
    const shareholders = useMemo(
        () =>
            [...new Map(rows.map(r => [r.shareholder_id, r])).values()],
        [rows]
    );

    return (
        <div className="p-4 bg-white">

            <div className="d-flex justify-content-between align-items-center mb-2">
                <h5 className="fw-bold mb-0">Shareholder Profit Report</h5>
                <button className="btn btn-success" onClick={() => setShowPayModal(true)}>
                    Pay Shareholder
                </button>
            </div>

            {/* FILTERS */}
            <div className="d-flex align-items-end justify-content-end gap-3 mb-3">

                <div style={{ minWidth: "180px" }}>
                    <label className="form-label mb-1 fw-semibold">
                        Shareholder
                    </label>
                    <select
                        className="form-select"
                        value={shareholderFilter}
                        onChange={(e) =>
                            setShareholderFilter(e.target.value)
                        }
                    >
                        <option value="all">All Shareholders</option>
                        {shareholders.map(s => (
                            <option
                                key={s.shareholder_id}
                                value={s.shareholder_id}
                            >
                                {s.shareholder_name}
                            </option>
                        ))}
                    </select>
                </div>

            </div>

            {/* SUMMARY */}
            <div className="alert alert-light border d-flex justify-content-between mb-3">
                <strong>
                    Total Profit (All): ₹
                    {overallTotal.toLocaleString("en-IN")}
                </strong>
                <strong>
                    Filtered Total: ₹
                    {filteredTotal.toLocaleString("en-IN")}
                </strong>
            </div>

            {/* TABLE */}
            <div className="table-responsive">
                <table className="table table-bordered table-hover align-middle">
                    <thead className="table-light">
                        <tr>
                            <th>#</th>
                            <th>Date</th>
                            <th>Parent</th>
                            <th>Shareholder</th>
                            <th className="text-center">Equity</th>
                            <th className="text-center">Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="6" className="text-center">
                                    Loading...
                                </td>
                            </tr>
                        ) : filteredRows.length === 0 ? (
                            <tr>
                                <td
                                    colSpan="6"
                                    className="text-center text-muted"
                                >
                                    No records
                                </td>
                            </tr>
                        ) : (
                            filteredRows.map((r, i) => (
                                <tr
                                    key={i}
                                    className={
                                        r.is_parent
                                            ? "table-primary fw-bold"
                                            : ""
                                    }
                                >
                                    <td>{i + 1}</td>
                                    <td>{r.date}</td>

                                    <td>
                                        {r.parent_name}
                                        {r.is_parent && (
                                            <span className="badge bg-primary ms-2">
                                                PARENT
                                            </span>
                                        )}
                                    </td>

                                    <td className={r.is_parent ? "" : "ps-4"}>
                                        {!r.is_parent && (
                                            <span className="text-muted me-1">
                                                ↳
                                            </span>
                                        )}
                                        {r.shareholder_name}
                                    </td>

                                    <td className="text-center">
                                        {r.equity}%
                                    </td>

                                    <td className="text-center fw-bold text-success">
                                        ₹
                                        {r.amount.toLocaleString("en-IN")}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* PAY MODAL */}
            {showPayModal && (
                <div className="modal fade show" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Shareholder Payment</h5>
                                <button type="button" className="btn-close" onClick={() => setShowPayModal(false)}></button>
                            </div>
                            <form onSubmit={handlePaySubmit}>
                                <div className="modal-body">
                                    <div className="mb-3 d-flex justify-content-between align-items-center bg-light p-2 rounded">
                                        <span className="fw-bold">Bank Balance:</span>
                                        <span className="text-success fw-bold">₹{Number(bankBalance).toLocaleString("en-IN")}</span>
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Shareholder</label>
                                        <select
                                            className="form-select"
                                            value={payData.shareholder_id}
                                            onChange={(e) => setPayData({ ...payData, shareholder_id: e.target.value })}
                                            required
                                        >
                                            <option value="">Select Shareholder</option>
                                            {allShareholders.map(s => (
                                                <option key={s.id} value={s.id}>
                                                    {s.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Amount</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={payData.amount}
                                            onChange={(e) => setPayData({ ...payData, amount: e.target.value })}
                                            max={bankBalance}
                                            step="0.001"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={payData.date}
                                            onChange={(e) => setPayData({ ...payData, date: e.target.value })}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Remark</label>
                                        <textarea
                                            className="form-control"
                                            rows="2"
                                            value={payData.remarks}
                                            onChange={(e) => setPayData({ ...payData, remarks: e.target.value })}
                                            required
                                        ></textarea>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowPayModal(false)}>Cancel</button>
                                    <button type="submit" className="btn btn-success">Record Payment</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SharePaymentReport;




